export default __webpack_public_path__ + "images/loggedout/home/modularPage/modular_curve3-796622015ea9bd8c1b8fcfc9bc7f2cdd.png";